import { Timestamp } from "firebase/firestore";

interface DateObj {
  nanoseconds: number;
  seconds: number;
}

export function formatDate(dateInput: string | Date | Timestamp | DateObj): Date | null {
  if (dateInput instanceof Date) {
    return dateInput;
  }

  if (typeof dateInput === "string") {
    const parsed = new Date(dateInput);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  if (
    typeof dateInput === "object" &&
    typeof (dateInput as Timestamp).toDate === "function"
  ) {
    return (dateInput as Timestamp).toDate();
  }

  if (
    typeof dateInput === "object" &&
    typeof (dateInput as DateObj).seconds === "number" &&
    typeof (dateInput as DateObj).nanoseconds === "number"
  ) {
    return convertDateObject(dateInput as DateObj);
  }

  return null;
}

function convertDateObject(obj: DateObj): Date {
  return new Date(obj.seconds * 1000 + Math.floor(obj.nanoseconds / 1e6));
}
